import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Compass from '@arcgis/core/widgets/Compass';

function GHCompass(props) {
  const [compass, setCompass] = useState(null);

  useEffect(() => {
    if (props.view.ui.find('compass') != null ) {
      return;
    }

    const compassWidget = new Compass({
      id: 'compass',
      view: props.view,
      // container: 'widget-panel'
    });

    setCompass(compassWidget);
    props.view.ui.add(compassWidget, 'bottom-right');

    return function cleanup() {
      props.view.ui.remove(compass);
    };

  }, [props.view]);

  return null;
}

GHCompass.propTypes = {
  view: PropTypes.object
}

export default GHCompass